<h2 class="title">Create Pairing</h2>

<mat-dialog-content>
  <div class="form-container">
    <form [formGroup]="pairForm" (ngSubmit)="onSubmit()">
      <!-- Recipient Search -->
      <mat-form-field appearance="fill">
        <mat-label>Recipient ET Number</mat-label>
        <input type="text" matInput [readonly]="pairForm.get('recipient')?.disabled" [matAutocomplete]="recipientAuto" [formControl]="recipientSearchControl" (input)="filterRecipients()" />
        <button type="button" mat-icon-button matSuffix *ngIf="selectedRecipient && !pairForm.get('recipient')?.disabled" (click)="clearRecipientSelection($event)">
          <mat-icon>clear</mat-icon>
        </button>
        <mat-autocomplete #recipientAuto="matAutocomplete" [displayWith]="displayRecipientName">
          <mat-option *ngFor="let recipient of filteredRecipients" [value]="recipient">
            {{ recipient.enisNumber }} -
            <ng-container *ngIf="recipient.firstName || recipient.lastName; else showRecipientDob"> {{ recipient.firstName }} {{ recipient.lastName }} </ng-container>
            <ng-template #showRecipientDob>
              {{ recipient.dob }}
            </ng-template>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <!-- Donor Search -->
      <mat-form-field appearance="fill">
        <mat-label>Donor ET Number</mat-label>
        <input type="text" matInput [readonly]="pairForm.get('donor')?.disabled" [matAutocomplete]="donorAuto" [formControl]="donorSearchControl" (input)="filterDonors()" />
        <button type="button" mat-icon-button matSuffix *ngIf="selectedDonor && !pairForm.get('donor')?.disabled" (click)="clearDonorSelection($event)">
          <mat-icon>clear</mat-icon>
        </button>
        <mat-autocomplete #donorAuto="matAutocomplete" [displayWith]="displayDonorName">
          <mat-option *ngFor="let donor of filteredDonors" [value]="donor">
            {{ donor.enisNumber }} -
            <ng-container *ngIf="donor.firstName || donor.lastName; else showDonorDob"> {{ donor.firstName }} {{ donor.lastName }} </ng-container>
            <ng-template #showDonorDob>
              {{ donor.dob }}
            </ng-template>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Relation to Recipient</mat-label>
        <mat-select formControlName="relationToRecipient">
          <mat-option *ngFor="let relation of relations" [value]="relation">
            {{ relation }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Comments</mat-label>
        <textarea matInput formControlName="comments"></textarea>
      </mat-form-field>

      <mat-checkbox formControlName="compatible">Compatible</mat-checkbox>
      <mat-checkbox formControlName="addPairToMatchingPeriod" *ngIf="currentMatchingPeriod">Add pair to current matching period</mat-checkbox>

      <div class="button-container">
        <button mat-raised-button color="primary" type="submit" [disabled]="pairForm.invalid">Submit</button>
      </div>
    </form>
  </div>
</mat-dialog-content>
